import { render, staticRenderFns } from "./ModuleItem.vue?vue&type=template&id=02276686"
import script from "./ModuleItem.vue?vue&type=script&lang=js"
export * from "./ModuleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports